module.exports = __webpack_public_path__ + "static/about-insta-5@2x-db93cc6540f65191af1b082d518d206a.jpg";